export default () => ({
  interactionByUser: {},
  saleByUser: {},
  saleByGroup: {},
  interactionByGroup: {},
  interactionByUserFilter: null,
  saleByUserFilter: null,
  saleByGroupFilter: null,
  interactionByGroupFilter: null,
  interactionsByStateFilter: null,
  metricColors: null,
  users_pbx: {},
  stateInteractionByUser: {},
  stateInteractionByGroup: {},
  stateSaleByUser: {},
  stateSaleByGroup: {},
  funnel: {},
  status: {},
  interactions: {},
  filteredInteractionsByVariables: {},
  filteredInteractionsBySales: {},
  crmContentTypes: {},
  variablesStatus: {},
  needs:[],
  needsFilter: null,
  origins:[],
  originsFilter: null,
  businessLines:[],
  businessLinesFilter: null,
  zones:[],
  zonesFilter: null,
  companies:[],
  companiesFilter: null,
  dataGeneralManagement1: {},
  dataGeneralManagement2: {},
  dataGeneralCoordinator1: {},
  dataGeneralCoordinator2: {},

});
